var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "property-base",
    { attrs: { label: _vm.label.text, forInput: _vm.label.for } },
    [
      _vm._l(_vm.newValue, function(condition, idx) {
        return [
          _c("div", { key: condition.key, staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-10" },
              [
                _c("connection-action", {
                  attrs: {
                    value: condition,
                    availableConditions: _vm.conditions,
                    canWrite: _vm.canWrite
                  },
                  on: {
                    "set-condition": function($event) {
                      condition.conditionId = $event
                    },
                    "set-operator": function($event) {
                      condition.operator = $event
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-2 d-flex flex-column" }, [
              _vm.newValue.length !== 1
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-danger w-100",
                      class: { disabled: !_vm.canWrite },
                      on: {
                        click: function($event) {
                          return _vm.removeConditionAt(idx)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-minus" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              idx + 1 === _vm.newValue.length
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary mt-auto",
                      class: [_vm.addEnabled ? "" : "disabled"],
                      on: {
                        click: function($event) {
                          return _vm.addCondition()
                        },
                        mouseover: _vm.addBtnHover,
                        mouseleave: function($event) {
                          _vm.noAvailableConditionsError = false
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  )
                : _vm._e()
            ])
          ])
        ]
      }),
      _vm._v(" "),
      _vm.noAvailableConditionsError
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("error-message", {
                  attrs: {
                    message:
                      "There are no more conditions available for this connection."
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }